// <errorCode, messageKey> map
export const ERROR_MESSAGES: Map<number, string> = new Map([
    [10001, 'server_content_length_too_large'],
]);
